import ReactSelect from 'react-select';

import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { FontScale, getFontScale } from 'themes/mixins/getFontScale';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

import { SelectMotives, pickMotive } from './selectMotives.data';

export type StyledSelectProps = {
  scale?: FontScale;
  motive?: SelectMotives;
};

const Container = styled.div<StyledSelectProps>`
  position: relative;

  display: flex;
  flex-direction: column;

  ${({ motive }) => motive && pickMotive(motive)};
  ${({ scale }) => scale && getFontScale(scale)}

  ${mediaMinWidth.md(css`
    width: 100%;
  `)}
`;

const Select = styled(ReactSelect)`
  width: 100%;

  text-transform: uppercase;
  color: ${pickColor('grayDark')};
`;

export { Container, Select };
